module.exports = __webpack_public_path__ + "img/md-arrow-dropup-circle.43c410cf.svg";